import '../components/clients/clients.js'; import '../components/fields/fields.js';
import svg4everybody from 'svg4everybody';
global.svg4everybody = svg4everybody;
svg4everybody();